export enum DeviationConstants {
  GET_DEVIATIONS_REQUEST = 'GET_DEVIATIONS_REQUEST',
  GET_DEVIATIONS_SUCCESS = 'GET_DEVIATIONS_SUCCESS',
  GET_DEVIATIONS_FAILURE = 'GET_DEVIATIONS_FAILURE',

  GET_DEVIATIONS_CATEGORY_REQUEST = 'GET_DEVIATIONS_CATEGORY_REQUEST',
  GET_DEVIATIONS_CATEGORY_SUCCESS = 'GET_DEVIATIONS_CATEGORY_SUCCESS',
  GET_DEVIATIONS_CATEGORY_FAILURE = 'GET_DEVIATIONS_CATEGORY_FAILURE',
}
